import { movementReducer } from "./MovementReducer";
import { combineReducers } from "redux";
import { loadingReducer } from "./LoadingReducer";
import { loginReducer } from "./LoginReducer";
import productsReducer from "./ProductReducer";
import stockReducer from "./StockReducer";
import StorageReducer from "./StorageReducer";
import userReducer from "./UsersReducer";
import ReportsReducer from "./ReportsReducer";
import customersReducer from "./CustomersReducer";

const rootReducer = combineReducers({
  loading: loadingReducer,
  login: loginReducer,
  users: userReducer,
  products: productsReducer,
  stock: stockReducer,
  storage: StorageReducer,
  customers: customersReducer,
  movements: movementReducer,
  reports: ReportsReducer,
});

export default rootReducer;
